import { getDueWorkingDay } from '../../../../../../../../../../../../../lib/functions/dates';

export const calculatePaymentDates = (
  creditDetails: any,
  firstPaymentDate: Date,
  workingDayActive: 'active' | 'inactive',
  operationDate: Date,
) => {
  const paymentDates: any[] = [];

  const currentDate = new Date(firstPaymentDate);
  currentDate.setUTCHours(12, 0, 0, 0);
  let quotaPaymentDate = new Date(firstPaymentDate);
  quotaPaymentDate.setUTCHours(12, 0, 0, 0);
  if (workingDayActive === 'active') {
    quotaPaymentDate = getDueWorkingDay(currentDate);
    quotaPaymentDate.setUTCHours(12, 0, 0, 0);
  }
  let diffDays = Math.floor(
    (quotaPaymentDate.getTime() - operationDate.getTime()) /
      (1000 * 60 * 60 * 24),
  );
  const date = new Date(quotaPaymentDate);
  date.setUTCHours(12, 0, 0, 0);
  paymentDates.push({ date, diffDays });

  for (let i = 1; i < creditDetails.months; i++) {
    const daysToAdd = calculateDateToAdd(creditDetails);
    console.log('daysToAdd', daysToAdd);
    // Dias oficiales de pago
    currentDate.setDate(currentDate.getDate() + daysToAdd);
    currentDate.setUTCHours(12, 0, 0, 0);
    // Dia movible si no es día hábil
    quotaPaymentDate = new Date(currentDate);
    quotaPaymentDate.setUTCHours(12, 0, 0, 0);
    if (workingDayActive === 'active') {
      quotaPaymentDate = getDueWorkingDay(currentDate);
      quotaPaymentDate.setUTCHours(12, 0, 0, 0);
    }
    const lastEntry = paymentDates[i - 1];
    diffDays =
      (quotaPaymentDate.getTime() - lastEntry.date.getTime()) /
      (1000 * 60 * 60 * 24);
    const newDate = new Date(quotaPaymentDate);
    newDate.setUTCHours(12, 0, 0, 0);
    paymentDates.push({ date: newDate, diffDays: diffDays });
  }

  return paymentDates;
};

export const calculateDateToAdd = (creditDetails: any) => {
  const daysSegment = creditDetails.periodicity;
  switch (daysSegment) {
    case 'WEEKLY':
      return 7;
    case 'BIWEEKLY':
      return 14;
    case 'MONTHLY':
      return 30;
    case 'BIMONTHLY':
      return 60;
    case 'QUARTERLY':
      return 90;
    case 'SEMI_ANNUAL':
      return 180;
    case 'ANNUAL':
      return 360;
    default:
      return 30;
  }
};
